<template>
  <div>
    <div><el-button type="primary" :style="buttonStyle" ><a :href="file" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" >Download FSHOW Sponsership Package</a></el-button></div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  data: () => ({
     saveBtnStatue:false,  //保存铵钮状态
      tableData: [],
      getDataString:"广告申请", //获取数据，提交数据 使用
      allData:[{
        text:"费用合计：",
        price:0
      }],
      totalPrice: 0,
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      file:'./FSHOW2025 Sponsorship Package.pdf'
  }),

  components: {},
  mounted() {

  },
  methods: {
    downfile(){

    },


  }
}
</script>
<style lang="less">


</style>

